var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserverseSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M308.052 492.962C303.815 533.088 311.63 573.562 330.507 609.268C349.385 644.974 378.478 674.308 414.109 693.561C449.739 712.813 490.305 721.119 530.679 717.429C571.053 713.739 609.42 698.218 640.93 672.83C672.44 647.441 695.677 613.324 707.703 574.793C719.73 536.263 720.005 495.049 708.494 456.362C696.983 417.676 674.203 383.255 643.035 357.452C611.866 331.649 573.709 315.623 533.388 311.4C489.268 306.64 444.796 316.4 406.78 339.185",
    stroke: "#609C5E",
    strokeOpacity: 0.54,
    strokeWidth: 70,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.984 254.645C187.081 318.283 148.878 403.051 143.624 492.864C138.37 582.677 166.431 671.284 222.481 741.871C278.532 812.458 358.671 860.112 447.692 875.791C536.713 891.469 628.421 874.081 705.412 826.926C782.402 779.771 839.319 706.13 865.36 619.979C891.401 533.827 884.754 441.16 846.682 359.562C808.609 277.964 741.76 213.114 658.82 177.318C575.879 141.523 482.62 137.272 396.739 165.374",
    stroke: "#609C5E",
    strokeOpacity: 0.54,
    strokeWidth: 70,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M545.75 695.522C545.75 711.435 552.071 726.697 563.324 737.949C574.576 749.201 589.837 755.522 605.75 755.522C621.663 755.522 636.924 749.201 648.176 737.949C659.429 726.697 665.75 711.435 665.75 695.522C665.75 679.609 659.429 664.348 648.176 653.096C636.924 641.844 621.663 635.522 605.75 635.522C589.837 635.522 574.576 641.844 563.324 653.096C552.071 664.348 545.75 679.609 545.75 695.522Z",
    fill: "#609C5E",
    stroke: "#609C5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M645 203C645 218.913 651.321 234.174 662.574 245.426C673.826 256.679 689.087 263 705 263C720.913 263 736.174 256.679 747.426 245.426C758.679 234.174 765 218.913 765 203C765 187.087 758.679 171.826 747.426 160.574C736.174 149.321 720.913 143 705 143C689.087 143 673.826 149.321 662.574 160.574C651.321 171.826 645 187.087 645 203Z",
    fill: "#609C5E",
    stroke: "#609C5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M452 512C452 527.913 458.321 543.174 469.574 554.426C480.826 565.679 496.087 572 512 572C527.913 572 543.174 565.679 554.426 554.426C565.679 543.174 572 527.913 572 512C572 496.087 565.679 480.826 554.426 469.574C543.174 458.321 527.913 452 512 452C496.087 452 480.826 458.321 469.574 469.574C458.321 480.826 452 496.087 452 512Z",
    fill: "#609C5E",
    stroke: "#609C5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserverseSmallLogo);
export default __webpack_public_path__ + "static/media/userverse-small-logo.33bd3a2df1f2147b8a2b1f670ea6806a.svg";
export { ForwardRef as ReactComponent };